import { documentationActions } from '../../actions/constant';

const {
    SUCCESS_SEND_MAIL_TO_PHYSICIAN,
    FAILURE_SEND_MAIL_TO_PHYSICIAN,
    LOADING_SEND_MAIL_TO_PHYSICIAN,
    RESET_SEND_MAIL_TO_PHYSICIAN
} = documentationActions;

const intitialstate: object = {
  response: null,
  sendMail: false,
  isLoading: false,
};

export const sendMailToPhysicianReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case SUCCESS_SEND_MAIL_TO_PHYSICIAN: {
      return {
        ...state,
        sendMail: true,
        response: action.payload,
        isLoading: false,
      };
    }

    case FAILURE_SEND_MAIL_TO_PHYSICIAN:
      return {
        ...state,
        sendMail: false,
        response: action.payload,
        isLoading: false,
      };

    case LOADING_SEND_MAIL_TO_PHYSICIAN: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case RESET_SEND_MAIL_TO_PHYSICIAN:
      return intitialstate;

    default:
      return state;
  }
};
